import type React from "react";
import { useState } from "react";
import { useGetSpeakingFeedbackByUserQuery } from "../../../../../entities/SpeakingFeedback/speakingFeedbackApi";
import type { SpeakingFeedbackAttempts } from "../../../../../entities/SpeakingFeedback/types/speakingFeedback";
import FeedbackDetails from "../FeedbackDetails/FeedbackDetails";
import style from "./Feedback.module.scss";

interface FeedbackProps {
	userId: string;
	speakingActivityId: string;
}

export const FeedbackComponent: React.FC<FeedbackProps> = ({
	userId,
	speakingActivityId,
}) => {
	const [openFeedbackModal, setOpenFeedbackModal] = useState(false);
	const [chosenFeedback, setChosenFeedback] =
		useState<SpeakingFeedbackAttempts>({
			answer: "",
			score: 0,
			feedback: "",
			createdAt: "",
		});

	const { data: attempts, isLoading: isFetching } =
		useGetSpeakingFeedbackByUserQuery({
			userId: userId,
			speakingActivityId: speakingActivityId,
		});
	return (
		<div>
			<FeedbackDetails
				isOpen={openFeedbackModal}
				onClose={() => setOpenFeedbackModal(false)}
				feedback={chosenFeedback}
			/>
			<h2>Scores and Feedback</h2>
			<div className={style.feedbackContainer}>
				{isFetching
					? "Loading feedback..."
					: attempts?.map((attempt) => (
							<div
								onClick={() => {
									setChosenFeedback(attempt);
									setOpenFeedbackModal(true);
								}}
								onKeyDown={(event) => {
									if (event.key === "Enter" || event.key === " ") {
										setChosenFeedback(attempt);
										setOpenFeedbackModal(true);
									}
								}}
								className={style.feedbackItem}
								key={attempt._id}
							>
								<p>{attempt?.score}</p>
							</div>
						))}
			</div>
		</div>
	);
};
